import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withViewModelService, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { ActivitiesService, SearchService } from 'gw-capability-gateway';
import { FormModalPopover } from 'ml-components-platform-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLBundleService } from 'ml-services-common-react';

import mlNoteDetailPopupMsg from '../MLNoteDetailPopup/MLNoteDetailPopup.messages';
import mlNoteDetailPopupMetadata from '../MLNoteDetailPopup/MLNoteDetailPopup.metadata.json5';

import MLFollowUpReportAdditionalFilter from './MLFollowUpReportAdditionalFilter';
import mlActivityDetailPopupMsg from '../MLActivityDetailPopup/MLActivityDetailPopup.messages';
import mlActivityDetailPopup from '../MLActivityDetailPopup/MLActivityDetailPopup';

import mlBundleQuestionPopup from '../MLBundleQuestionPopup/MLBundleQuestionPopup';
import mlBundleQuestionPopupMsg from '../MLBundleQuestionPopup/MLBundleQuestionPopup.messages.js';

import styles from '../ActivityReportsComponent/ActivityReportsComponent.module.scss';
import messages from './MLFollowUpsReportComponent.messages';
import metadata from './MLFollowUpsReportComponent.metadata.json5';

import { Button } from '@jutro/legacy/components';

const today = moment();
const yesterday = moment().subtract(1, 'days');
const tomorrow = moment().add(1, 'days');

const MLFollowUpsReportComponent = (props) => {
    const modalApi = useModal();
    const {
        rowLimit,
        isDashboard,
        isCompactView,
        filterBy,
        history,
        viewModelService,
        convertLocalDateToDate,
        isPcsIa,
        isFromLanding
    } = props;
    const translator = useTranslator();

    const {
        showErrorModal,
        showProgressDialog
    } = MLModalService();

    const { authHeader } = useAuthentication();

    const { refreshData } = useDataRefresh();
    const [isLoading, updateIsLoading] = useState(false);
    const [filteredJobs, updateFilteredJobs] = useState([]);
    const [resultsRowCount, updateResultsRowCount] = useState(0);
    const [filterData, updateFilterData] = useState({});
    const [assignedByValues, updatAassignedByValues] = useState([]);
    const isTasksScreen = filterBy === 'other';

    const prioritiesTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('Priority');

    const createAssignedByValues = useCallback((jobs) => {
        return Array.from(new Set(jobs.map((job) => job.assignedBy)));
    }, []);

    const loadFollowupsData = async () => {
        updateIsLoading(true);

        let response;
        if (isTasksScreen) {
            response = isDashboard
                ? await ActivitiesService.getTasksForUser(rowLimit, filterData, authHeader)
                : await ActivitiesService.getTasksForUser(null, filterData, authHeader);
        } else {
            response = isDashboard
                ? await ActivitiesService.getActivitiesForUserML(rowLimit, filterData, authHeader)
                : await ActivitiesService.getActivitiesForUserML(null, filterData, authHeader);
        }

        updateFilteredJobs(response);
        updateIsLoading(false);
        updateResultsRowCount(response.length);
        if (isTasksScreen && (_.isUndefined(assignedByValues) || _.isEmpty(assignedByValues))) {
            updatAassignedByValues(createAssignedByValues(response));
        }
    };

    useEffect(() => {
        loadFollowupsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onFilter = () => {
        loadFollowupsData();
    };

    const onClearFilters = () => {
        updateFilterData({});
    };

    const isOverdue = (dueDate)=> {
        return moment(dueDate).isBefore(moment(), 'd');
    };

    const renderDueDateValue = (dueDate) => {
        const aDate = convertLocalDateToDate(dueDate);
        const date = moment(aDate);
        if (date.isSame(yesterday, 'd')) {
            return translator(messages.yesterday);
        }
        if (date.isSame(today, 'd')) {
            return translator(messages.today);
        }
        if (date.isSame(tomorrow, 'd')) {
            return translator(messages.tomorrow);
        }
        return translator(messages.due, { date: aDate });
    }

    const renderDueDateCell = (item) => {
        if (!item.dueDate) {
            return '-'
        }
        let dueDateClass = '';
        if (isOverdue(item.dueDate)) {
            dueDateClass = 'error-text';
        }
        return  (
            <span className={dueDateClass}>
                {renderDueDateValue(item.dueDate)}
            </span>
        )
    };

    const renderCustomerName = (item) => {
        if(_.isUndefined(item.displayName)) {
            return '-'
        }
        return (
            <Link to={`/accounts/${item.accountNumber}/summary`} className={styles.linkCellValue}>
                <span className={styles.capitalize}>{item.displayName.toLowerCase()}</span>
            </Link>
        )
    };

    const renderProductCell = (item) => {
        return item.productName ? item.productName : '-';
    };

    const renderPolicyCell = (item) => {
        const redirectQuote = () => {
            if (item.isBundled) {
                MLBundleService.updateBundleAndGotoAgentBundleCart(item.accountNumber, item.jobNumber, showProgressDialog, viewModelService, showErrorModal, history, authHeader);
            } else {
                const request = { searchParam: item.jobNumber};
                const searchPromise = SearchService.searchByJobNumber(request, authHeader);
                searchPromise.then((searchResult) => {
                    if (searchResult.searchAccountDetails[0]) {
                        const jobNumber = searchResult.searchAccountDetails[0].searchResultJobNumber;
                        const postalCode = searchResult.searchAccountDetails[0].searchResultJobPostalCode;
                        const isBookrollWithRateCapping = searchResult.searchAccountDetails[0].searchResultJobBookrollIndicator === 'With Rate Capping';
                        const jobStatus = searchResult.searchAccountDetails[0].searchResultJobStatus;
                        const isAlaska7Day = searchResult.searchAccountDetails[0].address.state === 'AK' && searchResult.searchAccountDetails[0].searchResultJobTerm === '7 days';

                        if (isBookrollWithRateCapping || isAlaska7Day) {
                            if (jobStatus === 'Quoted') {
                                // $state.go('quoteentry', {quoteID: jobNumber, postalCode: postalCode});
                            } else {
                                const modalTitle = translator(messages.quoteNotComplete);
                                let modalMsg = '';
                                if (isBookrollWithRateCapping) {
                                    modalMsg = translator(messages.contactBookManager);
                                } else if (isPcsIa) {
                                    modalMsg = translator(messages.quoteNotCompleteCall);
                                } else {
                                    modalMsg = translator(messages.quoteToCompleteInPC);
                                }
                                showErrorModal(modalTitle, modalMsg);
                            }
                        } else {
                            const componentProps = {
                                title: mlBundleQuestionPopupMsg.savedQuote,
                                overrideProps: {
                                    accountNumber: searchResult.searchAccountDetails[0].accountNumber,
                                    quoteNumber: jobNumber,
                                    postalCode: postalCode,
                                    history,
                                    viewModelService,
                                    authHeader
                                },
                                CustomComponent: mlBundleQuestionPopup,
                                showFooterOnCustomComponent: false,
                                additionalPEStyle: 'customFooterModal'
                            };

                            modalApi.showModal(
                                <FormModalPopover {...componentProps} />
                            );
                        }
                    }
                }, () => {
                    console.error(new Error('Unable to retrieve submission'));
                });
            }
        };

        if(item.policyNumber || item.jobNumber) {
            if(item.jobNumber && !item.policyNumber) {
                return (
                    <Button onClick={redirectQuote} type="text">{item.jobNumber}</Button>
                )
            }
            if(item.policyNumber) {
                return (
                    <Link to={`/policies/${item.policyNumber}/summary`} className={styles.linkCellValue}>
                        {item.policyNumber}
                    </Link>
                )
            }
        }
        return translator(messages.account);
    };

    const renderInitiatorCell = (item) => {
        if (item.initiator_ML) {
            return item.initiator_ML;
        }
        return '-';
    };

    const updateActivities = (activities) => {
        updateFilteredJobs(activities);
        refreshData();
    }

    const renderNoteCell = (item) => {
        if (!item.subject) {
            return '-';
        }

        const openAddNoteDialog = (noteVM) => {
            const addNote = () => {
                ActivitiesService.createNoteForActivity(item.publicID, noteVM.value, authHeader)
                    .then((newNote) => {
                        item.notes.push(newNote);
                        MLTagManagerService.sendFormCompleteEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add Note Follow Up`);
                        
                        // TY Need check this. openAddNoteDialog and openActivityDetailModal references each other
                        // openActivityDetailModal(true);
                    });
            };

            const componentProps = {
                title: mlNoteDetailPopupMsg.addNote,
                uiProps: mlNoteDetailPopupMetadata.componentContent,
                actionBtnLabel: _.upperCase(translator(mlNoteDetailPopupMsg.addNote)),
                cancelBtnLabel: mlNoteDetailPopupMsg.cancelModal,
                disableButton: (vm) => !(_.get(vm, 'aspects.valid') && vm, _.get(vm, 'aspects.subtreeValid')),
                viewModel: noteVM,
                getOverrideProps: () => {
                    return {
                        policyAccountNumber: {
                            label: _.get(noteVM, 'value.policyNumber_ML') ? translator(mlNoteDetailPopupMsg.policyNumber) : translator(mlNoteDetailPopupMsg.accountNumber),
                            path: _.get(noteVM, 'value.policyNumber_ML') ? 'policyNumber_ML' : 'accountNumber'
                        }
                    }
                },
                onSaveAction: () => {
                    addNote();
                    return true;
                },
                buttonType: 'secondary'
            };
    
            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        }

        const openActivityDetailModal = (isReopeningAfterAddingNote) => {
            if (!isReopeningAfterAddingNote) {
                MLTagManagerService.sendFormStartEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Edit Follow Up`);
            }

            const componentProps = {
                title: mlActivityDetailPopupMsg.activityDetail,
                overrideProps: {
                    activity: item,
                    openAddNoteDialog,
                    filteredJobs,
                    updateActivities
                },
                CustomComponent: mlActivityDetailPopup,
                showFooterOnCustomComponent: false,
                additionalPEStyle: 'customFooterModal',
                viewModelService,
                authHeader
            };

            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        };

        return (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a role="button"  tabIndex={0} onClick={() => openActivityDetailModal(true)} onKeyPress={(e) => {
                if (e.key === 'Enter') {
                    openActivityDetailModal(true);
                }
            }}>{item.subject}</a>
        )
    };

    const renderPriorityCell = (item) => {
        const priorityName = prioritiesTypelist.getCode(item.priority).name;
        const priority = translator({
            id: priorityName,
            defaultMessage: priorityName
        });
        return priority
    };

    const onViewAllButtonClicked = () => {
        const reportView = isTasksScreen? 'tasks-report' : 'followups-report';
        history.push('/activity-reports', {reportView : reportView} );
    }

    const overrideProps = {
        statusDesc: {
            visible: isLoading,
            content: translator(messages.loading)
        },
        followUpsResultFilterComponent: {
            visible: !isCompactView,
            filterData,
            onFilter,
            onClearFilters,
            resultsRowCount,
            updateFilterData,
            hideFields: ['PRODUCT', 'GROUP', 'PRODUCER'],
            showTranscludeRow: isTasksScreen,
            additionalFiltersComponent: MLFollowUpReportAdditionalFilter,
            additionalFilterProps: {
                assignedByValues,
                prioritiesTypelist
            }
        },
        followUpsReportTable: {
            data: _.filter(filteredJobs, (job) => job.status === 'open'),
            visible: !isLoading,
            defaultPageSize: rowLimit,
            noDataText: translator(messages.noFollowUpActivityFound),
            showPagination: !isCompactView,
            tableLabel: translator(messages.agentFollowUps)
        },
        viewAllFollowUpsButton: {
            visible: isDashboard && !isFromLanding,
            onClick: onViewAllButtonClicked,
            content: isTasksScreen ? translator(messages.viewAllTasks) : translator(messages.viewAllMyFollowUps),
            mlTagManagerLinkClick: isTasksScreen ? "Dashboard_activityReport_viewAll_tasks" : "Dashboard_activityReport_viewAll_myFollowUps"
        },
        priorityColumn: {
            visible: !isCompactView
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            renderDueDateCell,
            renderCustomerName,
            renderProductCell,
            renderPolicyCell,
            renderInitiatorCell,
            renderNoteCell,
            renderPriorityCell
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLFollowUpsReportComponent.propTypes = {
    rowLimit: PropTypes.number.isRequired,
    isDashboard: PropTypes.bool.isRequired,
    isCompactView: PropTypes.bool.isRequired,
    getCustomerDisplayNameRevert: PropTypes.func,
    history: PropTypes.shape({push: PropTypes.func}).isRequired,
    filterBy: PropTypes.string,
    convertLocalDateToDate: PropTypes.func.isRequired,
    isPcsIa: PropTypes.bool,
    isFromLanding: PropTypes.bool
}

MLFollowUpsReportComponent.defaultProps = {
    filterBy: undefined,
    isPcsIa: false,
    isFromLanding: false,
    getCustomerDisplayNameRevert: _.noop
}

export default withRouter(withViewModelService(MLFollowUpsReportComponent));
